"use client";
import React from "react";
import useId from "./useId.js";
import { lockScroll, unlockScroll, } from "@bookingcom/bui-core/utilities/scroll";
var useScrollLock = function () {
    var _a = React.useState(false), locked = _a[0], setLocked = _a[1];
    var id = useId();
    var handleLockScroll = React.useCallback(function () {
        lockScroll(id, function () { return setLocked(true); });
    }, [id]);
    var handleUnlockScroll = React.useCallback(function () {
        unlockScroll(id, function () { return setLocked(false); });
    }, [id]);
    return React.useMemo(function () { return ({
        scrollLocked: locked,
        lockScroll: handleLockScroll,
        unlockScroll: handleUnlockScroll,
    }); }, [locked, handleLockScroll, handleUnlockScroll]);
};
export default useScrollLock;
